import axios from 'axios';

const API_BASE_URL = 'https://active.miladcoolingindustry.com/api';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000
});

// Add request interceptor for debugging
api.interceptors.request.use(
    (config) => {
        console.log('Making request to:', config.url);
        console.log('Request data:', config.data);
        return config;
    },
    (error) => {
        console.error('Request error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for debugging
api.interceptors.response.use(
    (response) => {
        console.log('Response received:', response.data);
        return response;
    },
    (error) => {
        console.error('Response error:', error);
        return Promise.reject(error);
    }
);

export const submitRegistration = async (formData) => {
    try {
        const response = await api.post('/submit_registration.php', formData);
        return response.data;
    } catch (error) {
        if (error.code === 'NETWORK_ERROR') {
            throw { message: 'خطا در اتصال به سرور' };
        }
        throw error.response?.data || { message: 'خطای ناشناخته' };
    }
};

// Test function to check CORS
export const testCORS = async () => {
    try {
        const response = await api.options('/submit_registration.php');
        return response;
    } catch (error) {
        console.error('CORS test failed:', error);
        throw error;
    }

};
